module.exports = __webpack_public_path__ + "static/img/touxiang_1.3815ed03.png";